import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import HealthTab from '../../components/health-tab'
import VideoModalTwo from '../../components/video-modal-two'
import BgParallax from '../../components/bg-parallax'
import ClientOne from '../../components/client-one'
import Footer from '../../components/footer'

import aboutImg from '../../assets/images/health/02.jpg'
import cta from '../../assets/images/health/06.jpg'
import about from '../../assets/images/health/04.png'

import { healthCounter, healthFeature, teamData } from '../../data/health'
import CountUp from 'react-countup'

export default function IndexHealth() {
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 pb-0 d-table w-100">
        <div className="container">
            <div className="row mb-5">
                <div className="col-12">
                    <div className="title-heading text-center mt-4">
                        <h1 className="text-dark display-5 mb-4 fw-semibold"><span className="text-primary fw-bold">Take care of your</span> <br/> health anytime anywhere</h1>
                        <p className="text-muted para-desc mx-auto">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                        <Link to="#" className="btn btn-primary">Appointment</Link>
                    </div>
                </div>
            </div>
            <HealthTab/>
        </div> 
      
        <div className="container mt-100 mt-60">
            <div className="rounded-3 py-3 bg-primary">
                <div className="row" id="counter">
                    {healthCounter.map((item,index)=>{
                        return(
                            <div className="col-md-3 col-6" key={index}>
                                <div className="counter-box py-4 text-center">
                                    <h2 className="mb-0 text-white title-dark mt-2"><CountUp end={item.value}/>+</h2>
                                    <h6 className="counter-head text-light title-dark">{item.title}</h6>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    </section>

    <section className="section"> 
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-5 col-md-6">
                    <div className="position-relative">
                        <img src={aboutImg} className="img-fluid shadow-lg rounded-4" alt=""/>
                        <VideoModalTwo/>
                    </div>
                </div>
                <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                    <div className="section-title ms-md-4">
                        <h4 className="title mb-4">Our quality system is <br/> ready to help you!</h4>
                        <p className="text-muted">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                        <p className="text-muted">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. This might also explain why one can now find slightly different versions. Due to the age of the Lorem Ipsum text there are no copyright issues to contend with.</p>
                        <Link to="#" className="btn btn-primary">Read More</Link>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="section bg-light">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12 text-center">
                    <div className="section-title mb-4 pb-2">
                        <h4 className="title mb-4">Design Features & Services</h4>
                        <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                    </div>
                </div>
            </div>

            <div className="row">
                {healthFeature.map((item,index)=>{
                    let Icon = item.icon
                    return(
                        <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                            <div className="feature p-3 py-4 rounded">
                                <Icon className="text-primary float-start me-3 mt-2 h1"/>
                                <div className="content d-block overflow-hidden">
                                    <h4 className="title">{item.title}</h4>
                                    <p className="text-muted mt-2">{item.desc}</p>
                                    <Link to="#" className="text-dark">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    </section>

    <section className="section">
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <div className="section-title">
                        <h4 className="title mb-4">Our Specialist Team</h4>
                        <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                    </div>
                </div>
            </div>

            <div className="row">
                {teamData.map((item,index)=>{
                    return(
                        <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2" key={index}>
                            <div className="mt-4 pt-2">
                                <div className="team position-relative d-block text-center">
                                    <div className="image position-relative d-block overflow-hidden">
                                        <img src={item.image} className="img-fluid rounded" alt=""/>
                                        <div className="overlay rounded"></div>
                                    </div>
                                    <div className="content py-2 member-position bg-white border-bottom overflow-hidden rounded d-inline-block">
                                        <h4 className="title mb-0">{item.name}</h4>
                                        <small className="text-muted">{item.position}</small>
                                    </div>
                                    <ul className="list-unstyled team-social social-icon mb-0">
                                        {item.social.map((el,index)=>{
                                            return(
                                                <li className="list-inline-item m-x-2" key={index}><Link to="#" className="rounded"><i className={el}></i></Link></li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    </section>

    <section className="section">
        <BgParallax bg={cta}/>
        <div className="bg-overlay"></div>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-6 col-md-9 text-center">
                    <ClientOne textLight={true}/>
                </div>
            </div>
        </div>
    </section>

    <section className="section">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-md-5 order-1 order-md-2 text-end">
                    <img src={about} className="img-fluid bg-light rounded-bottom-pill" alt=""/>
                </div>

                <div className="col-md-7 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="section-title">
                        <h4 className="title mb-4">Let's do it together. <br/><span className="text-primary">With our team member</span></h4>
                        <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                        <ul className="list-inline mb-0">
                            <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Top Speciallist Doctor</li>
                            <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> State Of The Art Doctor Services</li>
                            <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Discount For All Medical Treatment</li>
                            <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Enroollment Is Quick And Easy</li>
                        </ul>
                        <div className="mt-4">
                            <Link to="#" className="btn btn-primary">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="section bg-light">
        <div className="container">
            <div className="bg-dark bg-cta-dark rounded-4 pb-lg-0 pb-sm-0 shadow">
                <div className="row justify-content-center align-items-center">
                    <div className="col-12 px-5 my-5">
                        <div className="text-start">
                            <h2 className="text-white para-desc title-dark">Health service or tips for <br/> Healthy living, you can find here</h2>
                            <p className="text-white-50 para-desc para-dark mb-4">Build responsive, mobile-first projects on the web with the world's most popular front-endcomponent library.
                            </p>
                            <button type="submit" className="btn btn-primary rounded">Stay connected</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Footer/>

    </>
  )
}
